import { ApiEndpoints } from "./apiEndpoints";
import { fetchData, setHeaderOptions } from "./apiHelpers";
import { GroupRow } from "./group.type";
import { GroupWithUserGroup } from "./groups.type";

export function addUserToGroup({
  groupId,
  userId,
}: {
  groupId: string;
  userId: string;
}) {
  try {
    const url = ApiEndpoints.group + "/add-user";

    const request = setHeaderOptions({
      method: "POST",
      body: { groupId, userId },
    });

    return fetchData<void>(url, request);
  } catch (error) {
    console.error("Error adding user to group:", error);
    throw error;
  }
}

export function getGroups() {
  const url = ApiEndpoints.group;
  const request = setHeaderOptions({ method: "GET" });
  return fetchData<GroupRow[]>(url, request);
}

export function createGroup({ name }: { name: string }) {
  const url = ApiEndpoints.group;
  const request = setHeaderOptions({
    method: "POST",
    body: { name },
  });
  return fetchData<GroupRow>(url, request);
}

export function deleteGroup(id: string) {
  const url = ApiEndpoints.group + `/${id}`;
  const request = setHeaderOptions({ method: "DELETE" });
  return fetchData<void>(url, request);
}

export function getGroupById(id: string) {
  const url = ApiEndpoints.group + `/${id}`;
  const request = setHeaderOptions({ method: "GET" });
  return fetchData<GroupRow>(url, request);
}

export function updateGroupName({ id, name }: { id: string; name: string }) {
  const url = ApiEndpoints.group + `/${id}`;
  const request = setHeaderOptions({
    method: "PATCH",
    body: { name },
  });
  return fetchData<GroupRow>(url, request);
}

export const getGroupsForUser = async (
  contactUserId: string
): Promise<GroupWithUserGroup[]> => {
  const slug = ApiEndpoints.group + `/user/${contactUserId}`;
  const options = await setHeaderOptions({ method: "GET" });
  return fetchData<GroupWithUserGroup[]>(slug, options);
};

export function removeUserFromGroup({
  groupId,
  userId,
}: {
  groupId: string;
  userId: string;
}) {
  try {
    const url = ApiEndpoints.group + "/remove-user";

    const request = setHeaderOptions({
      method: "POST",
      body: { groupId, userId },
    });

    return fetchData<void>(url, request);
  } catch (error) {
    console.error("Error removing user from group:", error);
    throw error;
  }
}
